import { definirAppDeclaree } from '@taki/app-runtime';
import appInfo from './taki.app.json';
import { importDemoDataset } from './demo-dataset.js';

/**
 * L'APP CROQUIS (`croquis`), UNE APP CANVAS DECLAREE (regle G23).
 *
 * PAS DE PORTE, DONC NI `taki.fields.json` NI `taki.screens.json` : le
 * niveau App Canvas retire le rail, l'app entiere est UNE surface. La
 * derogation est deja accordee et ECRITE dans `taki.app.json` (cle
 * `canvas.app`) ; `definirAppDeclaree` refuse la clef `appCanvas` sans elle,
 * et `pnpm canvas:check` confronte les deux en CI.
 *
 * L'ECRAN VIENT DU SOCLE (`EcranAppCanvas`, `@taki/app-runtime`) : le
 * gabarit reduit, la recherche et les stats reprises par la fiche, le filet
 * d'erreur, le chargement paresseux. L'app n'ecrit que `Surface.tsx`.
 *
 * LE CHARGEUR RESTE UN `import()` : la surface et son moteur ne partent dans
 * le bundle d'un client que s'il ouvre l'app. Le kit de la surface (galerie,
 * sauvegarde, conflits) : `docs/SURFACES-CANVAS.md`.
 *
 * LE JEU DE DEMONSTRATION (`demo`) n'importe jamais le moteur au chargement :
 * la vignette le charge a la demande, au clic sur Importer.
 */
export const croquisApp = definirAppDeclaree({
  fiche: appInfo,
  appCanvas: { charger: () => import('./Surface.js') },
  demo: { importer: ({ sdk, orgId }) => importDemoDataset(sdk, orgId) },
});

export default croquisApp;
